<template>
  <label
    :class="[
      'radio',
      { 'radio--disabled': disabled },
      { 'radio--checked': isChecked },
    ]"
  >
    <input
      :value="value"
      :name="name"
      type="radio"
      :disabled="disabled"
      :aria-checked="ariaChecked"
      :checked="isChecked"
      class="radio__input"
      @input="selectRadio"
    />
    <div v-sanitize-html="label" class="radio__label" />
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  name: string
  label: string
  value: string
  selectedValue: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<{
  (e: 'onSelect', value: string): void
}>()

const isChecked = computed(() => props.selectedValue === props.value)

const ariaChecked = computed(() => (isChecked.value ? 'true' : 'false'))

const selectRadio = () => {
  emit('onSelect', props.value)
}
</script>

<style lang="scss" scoped>
.radio {
  display: flex;
  align-items: center;
  gap: $spacing-4xs;
  padding: $spacing-5xs $spacing-3xs;
  color: $color-text;

  &--disabled {
    color: $color-text-light;
  }

  &__label {
    width: 100%;
    color: inherit;
    line-height: 1.25;
  }

  &__input {
    accent-color: $color-navigation;
  }
}
</style>
